export const Programming=[
    {
        id:1,
        skillName:"C Programming",
        percentage:85
    },
    {
        id:2,
        skillName:"C++ Programming",
        percentage:80
    },
    {
        id:3,
        skillName:"Javascript Programming",
        percentage:90
    },
    {
        id:4,
        skillName:"Python Programming",
        percentage:50
    }

]
export const WedDevelopment=[
    {
        id:1,
        skillName:"Html",
        percentage:90
    },
    {
        id:2,
        skillName:"CSS",
        percentage:80
    },
    {
        id:3,
        skillName:"Javascript",
        percentage:90
    },
    {
        id:4,
        skillName:"Bootstrap",
        percentage:70
    },
    {
        id:5,
        skillName:"React JS",
        percentage:85
    },
    {
        id:6,
        skillName:"FireBase",
        percentage:15
    },
    {
        id:7,
        skillName:"Tailwind Css",
        percentage:30
    },


]
export const UiDesign=[
    {
        id:1,
        skillName:"Figma",
        percentage:55
    },
    {
        id:2,
        skillName:"Canva",
        percentage:70
    },
    {
        id:3,
        skillName:"PhotoShop",
        percentage:20
    },
   
]